import React from "react";
import { Headphones, User } from "react-feather";
import { Link } from "react-router-dom";
import logo from "../component/img/logoa.jpeg";
import SellerNotification from "./SellerNotification";

function SellerNavbar() {
  const sellerId = localStorage.getItem("seller_id");
  const sellerName = localStorage.getItem("seller_first_name");

  // console.log("Seller name from localStorage:", sellerName);

  return (
    <header className="sticky-top">
      <nav className="navbar navbag navbar-expand-lg navbar-light py-1">
        <div className="container">
          <Link className="navbar-brand p-0" to="/">
            <img src={logo} alt="Toolband" className="brand-logo logo1" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#mobileMenu"
            aria-controls="mobileMenu"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse">
            <ul className="navbar-nav me-auto w-50"></ul>

            <div className="navbar-icons d-flex justify-content-center align-items-center">
               
               <SellerNotification/>

              {/* Conditional Rendering for Seller Login or Seller's Name */}
              {sellerId ? (
                <Link to="/seller/profile" className="text-dark mx-2 atag acnt2">
                  <User className="text-dark" />{" "}
                  <span className="text-dark">{sellerName}</span>
                </Link>
              ) : (
                <Link to="/seller/login" className="text-dark mx-2 atag acnt2">
                  <User className="text-dark" />{" "}
                  <span className="text-dark">Seller Login</span>
                </Link>
              )}
            </div>
          </div>
        </div>
      </nav>

      {/* Offcanvas Menu for Mobile */}
      {/* <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="mobileMenuLabel">
            Menu
          </h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          ></button>
        </div>
        <div className="offcanvas-body">
          <ul className="navbar-nav">
            <li className="nav-item">
              <a href="#" className="nav-link">
                Home
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link">
                Shop
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link">
                Categories
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link">
                Products
              </a>
            </li>
            <li className="nav-item">
              <a href="#" className="nav-link">
                Contact Us
              </a>
            </li>
          </ul>
        </div>
      </div> */}
    </header>
  );
}

export default SellerNavbar;
